import { BillF, DepositF, ReservationF, ReservationHeaderTab } from './types/reservation-detail.types'
import { ReservationContextProvider } from './context/reservation-context-provider'
import { ReservationDetailDataCourier } from './reservation-detail-viewer'

type ReservationDetailDataProps = {
  propertyId: string
  defaultReservedResourceId?: string
  refetchReservation: () => void
  setLoading: (value: boolean) => void
  reservation: ReservationF
  bills: BillF[]
  deposits: DepositF[]
  reservationLink: string | null
  onCancel: () => void
  readOnly: boolean
  defaultTabIndex?: ReservationHeaderTab
  unsavedChanges: (rrWithUnsavedChange?: string) => void
}

export function ReservationDetailData({
  readOnly,
  propertyId,
  defaultReservedResourceId,
  refetchReservation,
  setLoading,
  reservation,
  bills,
  deposits,
  reservationLink,
  onCancel,
  defaultTabIndex,
  unsavedChanges,
}: ReservationDetailDataProps) {
  return (
    <ReservationContextProvider reservation={reservation}>
      <ReservationDetailDataCourier //
        propertyId={propertyId}
        defaultReservedResourceId={defaultReservedResourceId}
        refetchReservation={refetchReservation}
        setLoading={setLoading}
        bills={bills}
        deposits={deposits}
        reservationLink={reservationLink}
        onCancel={onCancel}
        readOnly={readOnly}
        defaultTabIndex={defaultTabIndex}
        unsavedChanges={unsavedChanges}
      />
    </ReservationContextProvider>
  )
}
